import React, {PropTypes} from 'react';
import _ from 'lodash';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Translator from 'bazinga-translator';

class Search extends React.Component {

    static defaultProps = {from: null, to: null}

    constructor(props) {
        super(props);
        this.form = this.form;
        this.handleTextChange = _.debounce(this.handleTextChange, 500);
        this.state = {
            text: null,
            from: props.from || null,
            to: props.to || null,
            wrongDate: false,
            type: 0,
        }
    }

    componentDidMount() {
        // setRange(this.submit); // jquery datepicker init
    }

    handleTextChange(value) {
        const {text} = this.state;
        this.setState({
            text: value,
        });
    }

    handleDateFromChange(date) {
        const {from} = this.state;
        this.setState({
            from: date,
        });
    }

    handleDateToChange(date) {
        const {from} = this.state;
        this.setState({
            to: date
        });

    }

    handleTypeChange(value) {
        const {type} = this.state;
        this.setState({
            type: value,
        });
    }

    componentDidUpdate(prevProps, prevState) {

        let dataForm = Routing.generate('app_activity.get', {"q" : this.state.text, "type": this.state.type, "from": moment(this.state.from).format("MM/DD/YYYY"), "to": moment(this.state.to).format("MM/DD/YYYY")}) + '&length=10&start=0';

        if (prevState != this.state) {
            this.props.fetchData(dataForm);
        }

    }

    renderWarning() {
        if (this.state.wrongDate) {
            return (
                <div style={{position: 'absolute'}}>
                    WRONG DATE!!
                </div>
            )
        }
    }


    render() {
        return (
            <form action=""
                  method="GET"
                  ref={c => (this.form = c)}>
                <div className="searchbox -filters">
                    {this.renderWarning()}
                    <div className="input -small">
                        <label for="search">{Translator.trans('activity_feed.search', [], 'app')} </label>
                        <div className="input__field">
                            <input type="text"
                                   name="q"
                                   id="search"
                                   placeholder={Translator.trans('activity_feed.search_placeholder', [], 'app')}
                                   onChange={(value) => this.handleTextChange(value.target.value)}/>
                        </div>
                    </div>
                    <div className="datepicker -range">
                        <label for="date-start">{Translator.trans('activity_feed.date_from', [], 'app')} </label>
                        <DatePicker onChange={(date) => this.handleDateFromChange(date)}
                                    id="date-start"
                                    dateFormat="MM/DD/YYYY"
                                    selected={this.state.from}
                                    maxDate={this.state.to}
                                    placeholderText={Translator.trans('activity_feed.date_placeholder', [], 'app')}
                        />
                        <label for="date-end">{Translator.trans('activity_feed.date_to', [], 'app')} </label>
                        <DatePicker onChange={(date) => this.handleDateToChange(date)}
                                    id="date-end"
                                    dateFormat="MM/DD/YYYY"
                                    selected={this.state.to}
                                    minDate={this.state.from}
                                    placeholderText={Translator.trans('activity_feed.date_placeholder', [], 'app')}
                        />
                    </div>
                    <div className="select -small">
                        <label for="country">{Translator.trans('activity_feed.type', [], 'app')} </label>
                        <select name="type" vaule=""
                                onChange={(value) => this.handleTypeChange(value.target.value)}>
                            <option value="0" defaultValue>{Translator.trans('activity_feed.type_all', [], 'app')}</option>
                            <option value="1">{Translator.trans('activity_feed.type_estimation', [], 'app')}</option>
                            <option value="2">{Translator.trans('activity_feed.type_quick_responses', [], 'app')}</option>
                        </select>
                    </div>
                    <button type="submit"
                            className="btn -hidden">Submit
                    </button>
                </div>
            </form>
        );
    }
}

Search.propTypes = {
    fetchData: PropTypes.func.isRequired,
};

export default Search;



// WEBPACK FOOTER //
// ./src/_app/activity-feed/components/Search.jsx